export enum AllowanceCalculatorBlocks {
  ALLOCATION = 'ALLOCATION',
  DRY = 'DRY',
  WET = 'WET',
  TREATS = 'TREATS',
}
